<template>
  <div class="xueWeiIndex bg-grey">
    <!-- 上方按钮 -->
    <div class="content-width">
      <el-row class="button-group more-search">
        <el-button
          size="small"
          icon="el-icon-search"
          @click="searchB()"
          class="more-search-css"
        ></el-button>
        <el-input
          placeholder="请输入关键字搜索"
          v-model="searchInput"
          class="search-input"
          v-show="showS"
          @blur="keyWords(searchInput)"
        ></el-input>
        <el-button
          size="small"
          @click="allData()"
          :class="all ? 'search-parent-selected' : 'no-checked'"
          >全部</el-button
        >
<!--        <el-popover placement="bottom" trigger="click" v-model="visible1">-->
<!--          <el-row class="search-flex">-->
<!--            <el-button-->
<!--              size="small"-->
<!--              v-for="(item, index) in GSJL"-->
<!--              :key="index"-->
<!--              :class="item.checked ? 'select-checked' : 'no-checked'"-->
<!--              @click="select(item, index, 1)"-->
<!--              >{{ item.name }}</el-button-->
<!--            >-->
<!--          </el-row>-->
<!--          <el-button-->
<!--            slot="reference"-->
<!--            :class="one ? 'search-parent-selected' : 'no-checked'"-->
<!--          >-->
<!--            归属经络-->
<!--            <i class="el-icon-arrow-down"></i>-->
<!--          </el-button>-->
<!--        </el-popover>-->
<!--        <el-popover placement="bottom" trigger="click" v-model="visible2">-->
<!--          <el-row class="search-flex">-->
<!--            <el-button-->
<!--              size="small"-->
<!--              v-for="(item, index) in seachButton"-->
<!--              :key="index"-->
<!--              :class="item.checked ? 'select-checked' : 'no-checked'"-->
<!--              @click="select(item, index, 2)"-->
<!--              >{{ item.name }}</el-button-->
<!--            >-->
<!--          </el-row>-->
<!--          <el-button-->
<!--            slot="reference"-->
<!--            :class="two ? 'search-parent-selected' : 'no-checked'"-->
<!--          >-->
<!--            归属部位-->
<!--            <i class="el-icon-arrow-down"></i>-->
<!--          </el-button>-->
<!--        </el-popover>-->
<!--        <el-popover placement="bottom" trigger="click" v-model="visible3">-->
<!--          <el-row class="text-center">-->
<!--            <el-button size="small" @click="jingluo()" class="more-search-css"-->
<!--              >经络</el-button-->
<!--            >-->
<!--            &lt;!&ndash; <el-button size="small" @click="xuewei()" class="more-search-css">穴位</el-button> &ndash;&gt;-->
<!--          </el-row>-->
<!--          <el-button-->
<!--            slot="reference"-->
<!--            :class="three ? 'search-parent-selected' : 'no-checked'"-->
<!--          >-->
<!--            经络/穴位-->
<!--            <i class="el-icon-arrow-down"></i>-->
<!--          </el-button>-->
<!--        </el-popover>-->
      </el-row>
      <el-row class="tag-row my-tag">
        已选择：
        <el-tag
          v-for="(item, index) in selectLabel"
          :key="index"
          :type="item.id"
          closable
          @close="handleClose(item)"
          >{{ item.name }}</el-tag
        >
      </el-row>

      <el-row class="l-content" :gutter="22">
        <!-- 左边穴位列表 -->
        <el-col :span="18" class="bookList clearfix">
          <div>
            <el-row class="left-list">
              <el-col :span="3">
                <div class="block">
                  <!-- <img :src="$store.state.imgUrl+item.url" alt /> -->
                </div>
              </el-col>
              <el-col :span="24">
                <div class="tag-list">
                  <div v-for="(item1, index1) in reorder"
                         :key="index1" class="left-lists">
                    <el-row>
                      <el-col :span="3">
                        <el-tag>{{ item1.name }}</el-tag>
                      </el-col>
                      <el-col :span="21">
                        <el-tag style="cursor: pointer" type="info" v-for="(j, i) in item1.valuelist"  @click="xueweiD(j.acupointList)" :key="i">{{ j.positionName }}</el-tag>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!-- <el-row>
              <el-col :span="24">
                <div class="view-more" @click="moreDate()">查看更多</div>
              </el-col>
            </el-row> -->
          </div>
        </el-col>
        <el-col :span="6">
              <img src="../assets/img/jingluotitle.png" alt="" style="cursor:pointer;" @click="goJl()">
        </el-col>
        <!-- 右边收藏列表 -->
        <el-col :span="6">
          <div class="right-list">
            <div class="collection-title">
              <img src="../assets/img/book.png" alt /> 腧穴的定位
            </div>
            <div class="list-one">
              <div
                @click="shuxueD(item.id)"
                v-for="(item, index) in shuXueList"
                :key="index"
              >
                {{ limitMaxWords(12, item.name) }}
              </div>
            </div>
          </div>
          <!-- 广告 -->
          <el-row>
            <el-col :span="24" class="adv-wrap">
              <div
                class="common-img-outer setPositon listdetail-adver-outer-img"
                v-for="(item, index) in jingxueAdverList"
                :key="index"
              >
                <a :href="item.urlLink">
                  <img :src="$store.state.imgUrl+item.urlImage" alt style="width: 100%" />
                  <span class="adver-words-tip" v-if="item.urlImage">{{
                    adverWordsTip
                  }}</span>
                </a>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "xueWeiIndex",
  data() {
    return {
      xueweiList: [],
      searchInput: "", //文本框搜索内容
      showS: false, //搜索框不显示
      visible1: false, //切换归属经络弹出层显示与否
      visible2: false, //切换归属部位弹出层显示与否
      visible3: false, //切换经络穴位弹出层显示与否
      all: true,
      one: false,
      two: false,
      three: false,
      four: false,
      gsjl: "", //归属经络
      gsbw: "", //归属部位
      seachButton: [], //归属部位
      GSJL: [], //归属经络
      selectLabel: [], //已选择的条件
      stackList: null,
      advList: [
        {
          url: require("../assets/img/32.png"),
        },
        {
          url: require("../assets/img/33.png"),
        },
      ],
    };
  },

  computed: {
    reorder() {
      // return this.xueweiList;
      return this.stackList;


      // return this.xueweiList.sort((x, y) => {
      //   return x["positionPinyin"].localeCompare(y["positionPinyin"]);
      // });
    },
  },

  methods: {
    goJl(){
      this.$router.push({
        path: "/JingLuoIndex"
      });
    },
    //腧穴详情
    shuxueD(id) {
      this.$router.push({
        path: "/shuxueDetail",
        query: { id: id },
      });
    },
    //穴位详情
    xueweiD(id) {
      //   console.log(id, "id");
      this.$router.push({
        path: "/xueWeiDetail",
        query: { id: id },
      });
    },
    //选一页的数量
    handleSizeChangeFun(v) {
      let that = this;
      that.pageInfo.pageSize = v;
      that.getList();
    },
    //选页
    handleCurrentChangeFun(v) {
      let that = this;
      that.pageInfo.pageNum = v; //当前页
      that.getList();
    },

    jingluo() {
      this.visible3 = false;
      this.$router.push({
        path: "/JingLuoIndex",
      });
    },
    xuewei() {
      this.visible3 = false;
      this.$router.push({
        path: "/xueWeiIndex",
      });
    },
    //搜索按钮
    searchB() {
      let that = this;
      if (that.showS) {
        that.showS = false;
      } else {
        that.showS = true;
      }
    },
    //全部
    allData() {
      let that = this;
      that.pageInfo1.pageNum = 1;
      that.xueweiList = [];
      that.searchInput = "";
      that.selectLabel = [];
      that.all = true;
      that.one = that.two = that.three = false;
      for (let c of that.GSJL) {
        c.checked = false;
      }
      that.GSJL[0].checked = true;
      for (let c of that.seachButton) {
        c.checked = false;
      }
      that.seachButton[0].checked = true;
      that.getList("", "", "");
    },
    //查看更多数据
    moreDate() {
      let that = this;
      that.pageInfo1.pageNum++;
      that.getList(that.searchInput, that.gsjl, that.gsbw);
    },
    //searchInput搜索框,gsjl归属经络,gsbw归属部位
    getList(searchInput, gsjl, gsbw) {
      let that = this;
      //   console.log("文本框关键字:" + searchInput);
      //   console.log("归属经络:" + gsjl);
      //   console.log("归属部位:" + gsbw);
      let url = "/jlxw/acupoint/positionAcupoints";
      let parmas = {
        pageNum: that.pageInfo1.pageNum,
        pageSize: that.pageInfo1.pageSize,
        meridians: gsjl,
        position: gsbw,
        name: searchInput,
      };
      that.$http
        .post(url, parmas)
        .then((res) => {
          if (res.data.code == 200) {
            let xueweiList1 = [];
            if (res.data.data.list.length == 0 && that.pageInfo1.pageNum > 1) {
              that.$message("没有更多穴位了！");
            }
            xueweiList1 = res.data.data.list.map((item, index) => {
              return {
                positionName: item.name,
                acupointList: item.id,
                positionPinyin: item.pinyin,
              };
            });

            //将得到的数据合并到上一次的数组中
            that.xueweiList = that.xueweiList.concat(xueweiList1);

            const newArr = xueweiList1.sort((a, b) => {
              return a['positionPinyin'].localeCompare(b['positionPinyin'])  //index是list你需要索引的字段名称
            })
            let stack = [
              {name : 'A',valuelist :[]},
              {name : 'B',valuelist :[]},
              {name : 'C',valuelist :[]},
              {name : 'D',valuelist :[]},
              {name : 'E',valuelist :[]},
              {name : 'F',valuelist :[]},
              {name : 'G',valuelist :[]},
              {name : 'H',valuelist :[]},
              {name : 'I',valuelist :[]},
              {name : 'J',valuelist :[]},
              {name : 'K',valuelist :[]},
              {name : 'L',valuelist :[]},
              {name : 'M',valuelist :[]},
              {name : 'N',valuelist :[]},
              {name : 'O',valuelist :[]},
              {name : 'P',valuelist :[]},
              {name : 'Q',valuelist :[]},
              {name : 'R',valuelist :[]},
              {name : 'S',valuelist :[]},
              {name : 'T',valuelist :[]},
              {name : 'U',valuelist :[]},
              {name : 'V',valuelist :[]},
              {name : 'W',valuelist :[]},
              {name : 'X',valuelist :[]},
              {name : 'Y',valuelist :[]},
              {name : 'Z',valuelist :[]},
            ]
            newArr.forEach(function(element) {
              stack.forEach(item => {
                if (item.name === element.positionPinyin[0].toUpperCase()) {
                  item.valuelist.push({positionName: element.positionName,positionPinyin: element.positionPinyin,acupointList: element.acupointList,})
                }
              })
            })
            let arr = []
            stack.forEach(j => {
              if (j.valuelist.length != 0) {
                arr.push(j)
              }
            })
            this.stackList = arr
          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
          that.$message("网络错误！");
        });
    },
    //得到归属经络
    getGSJL() {
      let that = this;
      let url = "/jlxw/meridians/meridiansList";
      that.$http
        .post(url)
        .then((res) => {
          if (res.data.code == 200) {
            that.GSJL = [];
            that.GSJL.push({
              id: "",
              name: "不限",
              checked: true,
            });
            for (let i = 0; i < res.data.data.length; i++) {
              that.GSJL.push({
                id: res.data.data[i].id,
                name: res.data.data[i].name,
                checked: false,
              });
            }
            // console.log(that.GSJL);
          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
          that.$message("网络错误！");
        });
    },
    //得到归属部位
    getGSBW() {
      let that = this;
      let url = "/jlxw/meridians/positionList";
      that.$http
        .post(url)
        .then((res) => {
          if (res.data.code == 200) {
            that.seachButton = [];
            that.seachButton.push({
              id: "",
              name: "不限",
              checked: true,
            });
            for (let i = 0; i < res.data.data.length; i++) {
              that.seachButton.push({
                id: res.data.data[i].id,
                name: res.data.data[i].name,
                checked: false,
              });
            }
            // console.log(that.seachButton);
          } else {
            that.$message(res.data.msg);
          }
        })
        .catch(() => {
          that.$message("网络错误！");
        });
    },
    //searchInput搜索框
    keyWords(searchInput) {
      let that = this;
      that.pageInfo1.pageNum = 1;
      that.xueweiList = [];
      that.getList(searchInput, that.gsjl, that.gsbw);
      that.all = false;
    },
    select(v, i, n) {
      let that = this;
      // 归属经络
      if (n == 1) {
        for (let c of that.GSJL) {
          if (c.checked && c.id != "") {
            for (var i = 0; i < that.selectLabel.length; i++) {
              if (that.selectLabel[i].id.indexOf(c.id) > -1) {
                //判断id为c.id的对象是否存在，
                let index = "";
                index = i;
                that.selectLabel.splice(index, 1); //存在即删除
              }
            }
          }
          c.checked = false;
        }
        // 判断是否有,有的话,就不添加到数组里
        let isExist = false;
        for (var i = 0; i < that.GSJL.length; i++) {
          if (that.GSJL[i] === v.name) {
            isExist = true;
            break;
          }
        }
        if (!isExist && v.id) {
          that.selectLabel.push({
            name: v.name,
            id: v.id,
          });
        }

        // console.log(that.selectLabel);

        v.checked = true;
        that.all = that.three = false;
        that.one = true;
        if (v.id) {
          that.one = true;
        } else {
          that.one = false;
        }
        that.visible1 = false;
        that.gsjl = v.id;
      }
      // 归属部位
      if (n == 2) {
        // console.log(that.seachButton);
        for (let c of that.seachButton) {
          if (c.checked && c.name != "不限") {
            for (var i = 0; i < that.selectLabel.length; i++) {
              if (that.selectLabel[i].id.indexOf(c.id) > -1) {
                //判断id为c.id的对象是否存在，
                let index = "";
                index = i;
                that.selectLabel.splice(index, 1); //存在即删除
              }
            }
          }
          // c.checked = false;
        }
        let isExist = false;
        for (var i = 0; i < that.selectLabel.length; i++) {
          if (that.selectLabel[i] === v.name) {
            isExist = true;
            break;
          }
        }
        if (!isExist && v.name != "不限") {
          that.selectLabel.push({
            name: v.name,
            id: v.id,
          });
        }
        // console.log(that.selectLabel);
        v.checked = true;
        that.all = that.three = false;
        that.two = true;
        if (v.name != "不限") {
          that.two = true;
        } else {
          that.two = false;
        }
        that.visible2 = false;
        that.gsbw = v.name;
      }
      that.xueweiList = [];
      that.pageInfo1.pageNum = 1;
      that.getList(that.searchInput, that.gsjl, that.gsbw);
    },
    //删除已选的某个标签
    handleClose(tag) {
      let that = this;
      that.selectLabel.splice(that.selectLabel.indexOf(tag), 1);
      for (let c of that.GSJL) {
        if (tag.id == c.id) {
          c.checked = false;
          that.GSJL[0].checked = true;
          that.all = that.one = that.three = false;
          that.gsjl = that.GSJL[0].id;
          break;
        }
      }
      for (let c of that.seachButton) {
        if (tag.id == c.id) {
          c.checked = false;
          that.seachButton[0].checked = true;
          that.all = that.two = that.three = false;
          that.gsbw = that.seachButton[0].id;
          break;
        }
      }
      if (that.selectLabel.length == 0) {
        that.all = true;
      }
      that.pageInfo1.pageNum = 1;
      that.xueweiList = [];
      that.getList(that.searchInput, that.gsjl, that.gsbw);
    },
  },
  created() {
    let that = this;
    that.getPositionAdver(5, 3);
    that.getList();
    that.getShuxueList();
    that.getGSBW();
    that.getGSJL();
  },
};
</script>

<style scoped>
.list-one {
  height: 232px;
  overflow: auto;
}
.left-list {
  padding: 20px;
  background-color: white;
  /* margin-right: 40px; */
  margin-bottom: 30px;
}
.tag-list {
  padding-top: 20px;
}
.el-tag+.el-tag{
  margin-left: 0px!important;
}
.el-tag{
  height: 25px;
  width: 62.5px;
  text-align: center;
  line-height: 25px;
  margin-right: 10px;
  cursor: pointer;
}
.left-lists{
  margin-bottom: 20px;
}
.content-width{
  padding-top:20px ;
 }
.button-group {
  text-align: left;
  padding: 0px 0px 20px;
}
.my-tag{
  padding: 0px 0px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/xueWeiIndex.vue